module.exports = __webpack_public_path__ + "static/media/bill.676cba98.svg";